import React from 'react';
import { AuditAction } from 'src/api/types';
import { Poppins } from 'src/common';
import { constantsNaming } from './util';
import { resolveVariableTokens } from '../variableTokens';
import useVariables from 'src/hooks/useVariables/useVariables';
import * as S from './ActionsGrid.styles';

interface IActionsGridProps {
  actions: AuditAction[];
}

export const ActionsGrid: React.FC<IActionsGridProps> = ({ actions }) => {
  // CRPD-7287 (I13): cost formulas are persisted id-form (`#500020`), so the Before/After cells
  // showed raw variable ids. Resolve them to names for display.
  const { variables } = useVariables({});

  if (!actions.length) return null;

  return (
    <>
      <S.Div data-cy="actions-grid">
        <div className="grid-block" />
        <div className="grid-block">
          <Poppins px={14} color="prussianBlue" weight={500} className="align-center">
            Before
          </Poppins>
        </div>
        <div className="grid-block">
          <Poppins px={14} color="prussianBlue" weight={500} className="align-center">
            After
          </Poppins>
        </div>
        {actions.map((el) => {
          const canRender =
            (typeof el.before === 'string' || typeof el.before === 'number' || el.before === null) &&
            (typeof el.after === 'string' || typeof el.after === 'number' || el.after === null);
          if (!canRender) return null;
          return (
            <React.Fragment key={el.field_name}>
              <div className="grid-block">
                <Poppins px={14} color="prussianBlue" weight={500} data-cy="ag-label">
                  {el?.url ? (
                    <a
                      href={el.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="table-link"
                      onClick={(e) => e.stopPropagation()}
                      data-cy="ag-label-link"
                    >
                      {el.field_name}
                    </a>
                  ) : (
                    el.field_name
                  )}{' '}
                </Poppins>
              </div>
              <div className="grid-block">
                <Poppins px={14} color="prussianBlue" weight={500} data-cy="ag-before">
                  {resolveVariableTokens(constantsNaming(el.field_name, el.before), variables)}
                </Poppins>
              </div>
              <div className="grid-block">
                <Poppins px={14} color="prussianBlue" weight={500} data-cy="ag-after">
                  {resolveVariableTokens(constantsNaming(el.field_name, el.after), variables)}
                </Poppins>
              </div>
            </React.Fragment>
          );
        })}
      </S.Div>
    </>
  );
};
